import React from "react";
import { Button, Col, Container, FormLabel, Row } from "react-bootstrap";
import {
  CustomerBillToSearchCriteria,
  PageListBean,
  RestCustomerBillToListRequest,
} from "../ds/ds.js";
import { LookupHandler, LookupResultDetails } from "../ds/lookup_ds.js";
import { Eraser, TickIcon } from "../gui_components/Icons.js";
import { InputTextbox, ShowError } from "../gui_components/UIComponents.js";
import { isEmptyString } from "../gui_components/Util.js";
import { CustomerService } from "../services/CustomerService.js";
export class CustomerBillToLookupHandler extends LookupHandler {
  constructor(companyCode, customerCode, attribute_name) {
    super();
    this.attribute_name = attribute_name;
    this.lookupTitle = attribute_name + " Lookup";
    this.companyCode = companyCode;
    this.customerCode = customerCode;
    let resetCriteria = new CustomerBillToSearchCriteria();
    resetCriteria.companyCode = companyCode;
    this.resetCriteria = resetCriteria;
    let customerLookupCriteria = new CustomerBillToSearchCriteria();
    customerLookupCriteria.companyCode = this.companyCode;
    this.customerLookupCriteria = customerLookupCriteria;
    let lookupCriteriaView = CustomerLookupCriteraHandler(
      companyCode,
      customerLookupCriteria
    );
    let newCriteria = new CustomerBillToSearchCriteria();
    newCriteria.companyCode = companyCode;
    this.newCriteria = newCriteria;
    let lookupDataCallback = function (
      lookup_dialog,
      page_number,
      searchCriteria,
      filterText
    ) {
      this.fetchDataFromService(
        lookup_dialog,
        page_number,
        searchCriteria,
        filterText
      );
    };
    this.setDetails(
      lookupDataCallback,
      customerLookupCriteria,
      lookupCriteriaView
    );
    this.initColumns();
  }
  initColumns() {
    this.addColumnDefinition(this.attribute_name, "code", 0, true); //1
    this.addColumnDefinition(
      this.attribute_name + " Name",
      "description",
      0,
      false
    ); //1
  }
  loadCustomerList = (lookup_dialog, pageNumber, searchCriteria) => {
    let cust_criteria = new CustomerBillToSearchCriteria(); //To be fetched from CriteriaHandler
    cust_criteria.companyCode = this.companyCode;
    cust_criteria.customerCode = this.customerCode;
    if (searchCriteria !== undefined && searchCriteria !== null) {
      cust_criteria.customerBilltoCode = searchCriteria.customerBilltoCode;
    }
    let cust_pageList = new PageListBean();
    cust_pageList.pageSize = 50; //TODO --> Fetch from Config
    cust_pageList.currentPage = pageNumber;
    cust_pageList.pageNumber = pageNumber;
    let cust_requestInput = new RestCustomerBillToListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = cust_criteria;
    CustomerService.getCustomerBillToPageList(
      cust_requestInput,
      (response) =>
        this.loadCustomerBillToListResponse(response, lookup_dialog),
      this.loadCustomerBillToListError
    );
  };
  loadCustomerBillToListResponse = (response, lookup_dialog) => {
    let customerBillToList = [];
    let totalCount = 0;
    let currentPageNumber = 0;
    let pageSize = 0;
    if (
      response.data.customerBillToPageList != null &&
      response.data.customerBillToPageList.customerBillTos !== null
    ) {
      customerBillToList = response.data.customerBillToPageList.customerBillTos;
      totalCount = response.data.customerBillToPageList.totalCount;
      currentPageNumber = response.data.customerBillToPageList.currentPage;
      pageSize = response.data.customerBillToPageList.pageSize;
    }
    let lookup_result_details = new LookupResultDetails();
    lookup_result_details.pageData = customerBillToList;
    let total_count = 0;
    if (this.lookup_data != null) {
      total_count = this.lookup_data.length;
    }
    lookup_result_details.totalRecordsCount = totalCount;
    lookup_result_details.currentPageNumber = currentPageNumber;
    lookup_result_details.pageSize = pageSize;
    lookup_result_details.criteriaDisplayString = ""; //TODO
    lookup_dialog.updateResultCallBack(lookup_result_details);
  };
  loadCustomerBillToListError = (error) => {
    ShowError("Error : " + error);
  };
  fetchDataFromService(lookup_dialog, pageNumber, searchCriteria, filterText) {
    let search = { ...searchCriteria };
    if (search != null && search != "unDefined") {
      // if (isEmptyString(search.customerBilltoCode)) {
      if (!isEmptyString(filterText)) {
        search.customerBilltoCode = filterText;
        this.searchCriteria = new CustomerBillToSearchCriteria();
      }
    }
    if (lookup_dialog != null) {
      this.loadCustomerList(lookup_dialog, pageNumber, search);
    }
  }
}
const CustomerLookupCriteraHandler = (companyCode, customerLookupCriteria) => {
  return class extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        searchCriteria: new CustomerBillToSearchCriteria(),
      };
      this.criteriaLookupHandler = React.createRef();
      this.focusRef = React.createRef();
    }
    componentDidMount() {
      let searchCriteria = this.state.searchCriteria;
      searchCriteria.companyCode = companyCode;
      this.setState({ searchCriteria: searchCriteria });
      if (this.focusRef.current) this.focusRef.current.focus();
    }
    continueButtonClick = () => {
      this.props.searchCriteriaCallBack(this.state.searchCriteria);
    };
    onChange = (e) => {
      let temp_searchCriteria = this.state.searchCriteria;
      temp_searchCriteria[e.target.name] = e.target.value;
      this.setState({ searchCriteria: temp_searchCriteria });
    };
    clearCriteria = () => {
      let searchCriteria = new CustomerBillToSearchCriteria();
      searchCriteria.companyCode = companyCode;
      this.setState({ searchCriteria: searchCriteria });
      if (this.focusRef.current) this.focusRef.current.focus();
    };
    onContainerKeyDown = (e) => {
      if (e.ctrlKey && e.keyCode == "191") {
        this.continueButtonClick();
      }
    };
    render() {
      let searchCriteria = this.state.searchCriteria;
      return (
        <div>
          <Container onKeyDown={this.onContainerKeyDown}>
            <Row>
              <Col sm={5}>
                <FormLabel>CustomerBilltoCode</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="customerBilltoCode"
                  name="customerBilltoCode"
                  onChange={this.onChange}
                  value={searchCriteria.customerBilltoCode}
                />
              </Col>
            </Row>
            <Row className="popup_criteria_button_align-lookup">
              <Button
                className="header_buttons btn btn-primary btn-sm enterFocus"
                onClick={this.continueButtonClick}
                ref={this.focusRef}
              >
                <TickIcon />
                Continue
              </Button>

              <Button
                className="header_buttons btn btn-primary btn-sm enterFocus"
                onClick={this.clearCriteria}
              >
                <Eraser />
                Clear
              </Button>
            </Row>
          </Container>
        </div>
      );
    }
  };
};
